export const customFieldsCopy = {
  sectionLabel: "Doplňující údaje",
  sectionDescription: "Na co se zeptáme zákazníka při rezervaci slevového termínu z této šablony.",
  emptyEditor: "Zatím se zákazníků na nic neptáte.",
  fieldOrdinal: (position: number) => `${position}. údaj`,
  labelAria: (position: number) => `Popisek ${position}. údaje`,
  labelPlaceholder: "např. Název týmu",
  typeAria: (position: number) => `Typ ${position}. údaje`,
  typeText: "Text",
  typeNumber: "Číslo",
  removeField: (position: number) => `Odebrat ${position}. údaj`,
  requiredToggle: "Povinné",
  minLabel: "Min.",
  minAria: (position: number) => `Minimum ${position}. údaje`,
  maxLabel: "Max.",
  maxAria: (position: number) => `Maximum ${position}. údaje`,
  maxLengthLabel: "Max. znaků",
  maxLengthAria: (position: number) => `Maximální délka ${position}. údaje`,
  maxLengthPlaceholder: "200",
  addField: "Přidat údaj",
  fieldCount: (used: number, limit: number) => `${used} z ${limit} údajů`,
  forbiddenTopicsNotice:
    "Ptát se nesmíte na zdravotní stav ani jiné zvláštní kategorie osobních údajů, na rodné číslo, čísla dokladů totožnosti ani na platební údaje (Podmínky pro partnery, čl. 7.2).",
  forbiddenTopicRefusal: {
    health: "na zdravotní údaje se ptát nesmíte (Podmínky pro partnery, čl. 7.2), upravte popisek",
    identity:
      "na rodné číslo ani čísla dokladů se ptát nesmíte (Podmínky pro partnery, čl. 7.2), upravte popisek",
    payment: "na platební údaje se ptát nesmíte (Podmínky pro partnery, čl. 7.2), upravte popisek",
    special:
      "na zvláštní kategorie osobních údajů se ptát nesmíte (Podmínky pro partnery, čl. 7.2), upravte popisek",
  },
  renamingKeepsAnswers:
    "Popisek můžete přejmenovat. Dřívější odpovědi si nesou popisek, pod kterým je zákazníci vyplnili.",
} as const;
